import React from "react";
import { statusLabel } from "../../TopUpUIHelpers";

export function StatusColumnFormatter(cellContent, row) {
  let value = statusLabel(cellContent);
  return (
    <span className={`label label-lg label-light-${value.type} label-inline`}>
      {value.name}
    </span>
  );
}
